export { useCommentsData, CommentsDataStore } from './useCommentsData';

export const updateAnnotations =
	(callbacks: ((annotations: string[]) => void)[]) => (annotationsList: string[]) => {
		callbacks.forEach((callback) => callback(annotationsList));
	};
